<template>
  <v-list>
    <SmsInput
      ref="refSmsInput"
      :userData="userData"
      @sendCode="clickSendCode"
    />

    <CodeInput
      :reqData="reqData"
      ref="refCodeInput"
      v-if="step === 'sent'"
      @gotoSmsInput="gotoSmsInput"
    />

    <v-btn
      v-if="step === 'sent'"
      color="primary"
      x-large
      depressed
      block
      rounded
      @click="completeCertify"
      >인증번호 확인</v-btn
    >
  </v-list>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SmsInput from "./smsForm/SmsInput.vue";
import CodeInput from "./smsForm/CodeInput.vue";
export default {
  components: {
    SmsInput,
    CodeInput,
  },
  props: {
    userData: {
      type: [Object],
    },
  },
  data() {
    return {
      step: "send",
      isSend: false,
      reqData: {
        endpoint: "sendCertifySms",
        smsSendMode: "changePassword", // 회원가입 인지 ? 비밀번호 찾기 모드인지?
        userCell: "",
        inputCode: "",
        code: "",
        isTest: "N", // sms test로 할때 Y
      },
    };
  },
  methods: {
    clickSendCode() {
      // 필수
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;

      let msg = `휴대폰번호를 입력해주세요`;
      if (!$h.requiredCheck(DT.cell, RF.refSmsInput.$refs.refCell, msg)) return;

      if (DT.cell.length < 10) return;

      this.isSend = false;
      this.userData.checkSms = false;
      this.reqData.userCell = this.userData.cell;
      this.reqData.code = this.$helper.randomNumber(1000, 9999);
      this.saveDataPreLoginQuery(this.reqData).then((res) => {
        if (res === undefined) return;
        console.log("res", res);
        if (res.resultCode === 0) {
          let msg = `회원가입된 아이디(휴대폰번호)가 아닙니다.`;
          $h.showTostMessage("", msg, "error");
          return;
        }
        console.log("userData", this.userData);

        this.step = "sent";
        this.isSend = true;
        this.userData.checkSms = true;
        this.userData.name = res.userName;
        setTimeout(() => {
          this.$refs.refCodeInput.$refs.refCode.focus();
          this.$refs.refCodeInput.startTimer(this.isSend);
        }, 1000);
      });
    },
    completeCertify() {
      console.log("", this.reqData);
      this.userData.checkedSms = false;
      const $h = this.$helper;
      const DT = this.reqData;
      const RF = this.$refs;
      let msg = `인증번호를 입력해주세요.`;
      if (!$h.requiredCheck(DT.inputCode, RF.refCodeInput.$refs.refCode, msg))
        return;

      if (Number(this.reqData.inputCode) !== Number(this.reqData.code)) {
        msg = `전달받은 인증번호를 확인해 주세요.`;
        $h.showTostMessage("", msg, "info");
        this.$refs.refCodeInput.$refs.refCode.focus();
        return;
      }

      this.userData.checkedSms = true;
      this.$emit("completeCertify", this.reqData);
    },
    // 입력안하면 초기화
    gotoSmsInput() {
      this.step = "send";
    },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
};
</script>
<style lang="">
</style>